// src/components/category_page/CategoryGrid.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.05 },
  }),
};

export default function CategoryGrid({ categories = [] }) {
  const safeCategories = Array.isArray(categories) ? categories.filter(Boolean) : [];

  if (!safeCategories.length) {
    return <p className="text-gray-600">Nincs megjeleníthető kategória.</p>;
  }

  return (
    <motion.div
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4"
      initial="hidden"
      animate="visible"
    >
      {safeCategories.map((cat, i) => {
        const title = cat.name || cat.id;
        const img = cat.image || "/media/categories/placeholder.webp";

        return (
          <motion.div key={cat.id || title} custom={i} variants={itemVariants}>
            <Link to={`/kategoriak/${cat.id}`} aria-label={`Ugrás a(z) ${title} kategóriára`}>
              <div className="bg-white shadow rounded p-4 hover:shadow-lg transition">
                <img
                  src={img}
                  alt={title}
                  className="w-full aspect-square object-cover rounded mb-2 bg-gray-50"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = "/img/placeholder.webp";
                  }}
                />
                <h2 className="text-lg font-semibold">{title}</h2>
              </div>
            </Link>
          </motion.div>
        );
      })}
    </motion.div>
  );
}
